import { FunctionComponent, HTMLProps, useRef, useState } from "react"
import * as Icons from "@nova/component-icons"
import { IconButton } from "@nova/component-btn"
import classNames from "classnames"

interface TitleInputProps {
    initialValue: string
    onCancel?: () => void
    onSubmit: (value: string) => void
}

export const TitleInput: FunctionComponent<
    TitleInputProps & Omit<HTMLProps<HTMLInputElement>, "onSubmit">
> = ({ initialValue, onCancel, onSubmit, className, ...rest }) => {
    const [inputValue, setInputValue] = useState(initialValue)
    const [isActive, setIsActive] = useState(false)
    const inputRef = useRef<HTMLInputElement>(null)

    const confirm = () => {
        onSubmit(inputValue)
        setIsActive(false)
        inputRef.current?.blur()
    }

    const cancel = () => {
        setInputValue(initialValue)
        onCancel?.()
        setIsActive(false)
        inputRef.current?.blur()
    }

    return (
        <div
            className={classNames(
                "flex gap-1 text-gray-100 data-[active=true]:text-white data-[active=true]:border-b-gray-700 border-b border-b-transparent",
                className
            )}
            data-active={isActive}
        >
            <input
                ref={inputRef}
                className="w-full bg-transparent p-0 border-none focus:outline-none text-[14px]"
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
                onFocus={() => setIsActive(true)}
                onKeyDown={(e) => {
                    if (e.key === "Enter") confirm()
                    if (e.key === "Escape") cancel()
                }}
                {...rest}
            />
            {isActive && (
                <>
                    <IconButton
                        onMouseDown={(e) => {
                            e.preventDefault()
                            confirm()
                        }}
                    >
                        <Icons.SmallIcon Icon={Icons.Checkmark} className="text-green-500" />
                    </IconButton>
                    <IconButton
                        onMouseDown={(e) => {
                            e.preventDefault()
                            cancel()
                        }}
                    >
                        <Icons.SmallIcon Icon={Icons.XClose} className="text-gray-400" />
                    </IconButton>
                </>
            )}
        </div>
    )
}
